/** Zero-CLS loading placeholder (SRS §7.6). Uses the shared `.skeleton` keyframe. */
export function Skeleton({
  className = '',
  rounded = 'rounded-md',
}: {
  className?: string;
  rounded?: string;
}): JSX.Element {
  return <div className={`skeleton ${rounded} ${className}`} aria-hidden />;
}

export function ProductCardSkeleton(): JSX.Element {
  return (
    <div className="@container overflow-hidden rounded-xl border border-frost bg-white">
      <Skeleton className="aspect-square w-full" rounded="rounded-none" />
      <div className="p-3 sm:p-4">
        <Skeleton className="h-5 w-16" rounded="rounded-full" />
        <Skeleton className="mt-2 h-10 w-full" />
        <Skeleton className="mt-3 h-11 w-3/4 @[240px]:h-6" />
        <Skeleton className="mt-3 h-11 w-full" />
      </div>
    </div>
  );
}
